export const baseURL = "https://global-share.onrender.com";

// export const baseURL = ""